import { configureStore, Action } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { ThunkAction } from 'redux-thunk';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import {createBrowserHistory} from "history";
import { routerMiddleware } from 'connected-react-router'

import rootReducer from './rootReducer';
import { hotjarMiddleware } from 'util/middlewares/hotjar.middleware';
import { checkUserStepMiddleware } from 'util/middlewares/checkUserStep.middleware';

export const history = createBrowserHistory();

const persistConfig = {
    key: 'proxibitstorage',
    storage : storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

const store = configureStore({
    reducer: persistedReducer,
    middleware: [
        hotjarMiddleware,
        thunk,
    ] as const
})


export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch()
export type AppThunk = ThunkAction<void, any, unknown, Action>

export const persistor = persistStore(store)

export default store
